var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H40C48.8366 0 56 7.16344 56 16V40C56 48.8366 48.8366 56 40 56H16C7.16344 56 0 48.8366 0 40V16Z",
    fill: "#ECFEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5816 23.9758C16.4095 22.5942 18.2233 20.9965 19.9674 19.2015C21.4832 17.6416 22.8542 16.0276 24.0685 14.3971C25.6561 12.2653 26.9756 10.105 28 8V28H8C10.1495 26.9957 12.3759 25.6432 14.5816 23.9758Z",
    fill: "#06B6D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28C45.8505 26.9957 43.6241 25.6432 41.4183 23.9758C39.5905 22.5942 37.7767 20.9965 36.0325 19.2014C34.5168 17.6416 33.1457 16.0276 31.9315 14.3971C30.3439 12.2653 29.0244 10.105 28 8V28H48Z",
    fill: "#67E8F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 28C10.1495 29.0043 12.3759 30.3568 14.5816 32.0242C16.4095 33.4058 18.2233 35.0035 19.9674 36.7985C21.4832 38.3584 22.8542 39.9724 24.0685 41.6029C25.6561 43.7347 26.9756 45.895 28 48V28H8Z",
    fill: "#0891B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C29.0244 45.895 30.3439 43.7347 31.9314 41.6029C33.1457 39.9724 34.5168 38.3584 36.0325 36.7986C37.7767 35.0035 39.5905 33.4058 41.4183 32.024C43.6241 30.3568 45.8505 29.0043 48 28H28V48Z",
    fill: "#22D3EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingBlueIcon);
export default __webpack_public_path__ + "static/media/pricing-blue-icon.fa1c96078703af07ccc2e3aa44959bce.svg";
export { ForwardRef as ReactComponent };